import { uncurlyUuid } from '@atlassian/bitkit-analytics';

export const FORGE_PRODUCT = 'bitbucket';

export const constructBitbucketWorkspaceAri = (workspaceUuid: string): string =>
  `ari:cloud:bitbucket::workspace/${uncurlyUuid(workspaceUuid)}`;
